const { BLAZE_MONITOR_RESTRICTED_FIELDS, BLAZE_MONITOR_MASK } = require('../constants');

function getHeaderTags(header) {
  return {
    'user-agent': getValue(header, 'user-agent'),
    host: getValue(header, 'host'),
    origin: getValue(header, 'origin'),
    referer: getValue(header, 'referer')
  };
}

function getValue(source, key) {
  const value = source && source[key] ? source[key] : null;
  if (BLAZE_MONITOR_RESTRICTED_FIELDS.includes(key) && value) return BLAZE_MONITOR_MASK;
  return value;
}

function getError(errors) {
  if (!errors || !Array.isArray(errors) || !errors.length) return errors;
  const error = errors[0]; // Get the first error That cause the failure.
  if (error.stack) return error;

  // Graphql errors are not providing stack so we need to create a stack trace.
  // But it has informative error type and value. We need to preserve these
  // information and also create a stack trace point the location of error reporting
  // in blaze code.
  const errorForStack = new Error(errors[0].message);
  error.stack = errorForStack.stack;
  return error;
}

/**
Various data scrubbing techniques are in use via various third-party monitors.
The following function, replaceRestrictedFields is not dealing with variable or
parameter value scrubbing. This method is only used for scrubbing string values
like query/mutation statement so that the third-pary doesn't clean it and developers
has a clear view of the query causing the error. Prefix of the word is kept as a
clue of what parameter sent for the command.

Example:
Input value:
"mutation login($identity: String!, $password: String!){
  login(input: {
    identity: $identity
    password: $password
  }){
    result
  }
}";

Output value:
"mutation login($identity: String!, $p*****:: String!){
  login(input: {
    identity: $identity
    p*****: $p*****
  }){
    result
  }
}";
*/
function replaceRestrictedFields(value) {
  if (!value) return value;

  let processedValue = value;
  BLAZE_MONITOR_RESTRICTED_FIELDS.forEach(field => {
    const fieldName = field[0] + BLAZE_MONITOR_MASK;
    processedValue = processedValue.replace(new RegExp(`${field}\\b`, 'ig'), `${fieldName}`);
  });

  return processedValue;
}

/**
Third-party monitors expects context details needs to be specified in specific format.
Following method, getProcessedRequestContext gets the graphql/koa request
details into the context. Individual plugins can reconvert as necessary.

Example input:
context: {
      ...
      state: {
        user: { id: null, groupId: 'previewId' },
        ...
      }
    },
    request: {
      extensions: {
        someQueryDetails: {
          version: 1,
          ...
        }
      },
      variables: {
        id: 'some information'
        ....
      }
    }
*/
function getProcessedRequestContext(requestContext) {
  const state = getValue(requestContext.context, 'state');
  const contexts = state ? { ...state } : {};
  if (!requestContext.request) return contexts;
  contexts.command = {
    mutation: replaceRestrictedFields(getValue(requestContext.request, 'query')),
    query: getValue(requestContext.request, 'operationName')
  };
  contexts.extensions = getValue(requestContext.request, 'extensions');
  contexts.variables = getValue(requestContext.request, 'variables');
  return contexts;
}

function getBreadcrumb(context) {
  const breadcrumbs = [];
  if (context && context.request && context.request.url) {
    breadcrumbs.push({
      category: 'url',
      message: context.request.url
    });
  }
  return breadcrumbs;
}

function getTags(context) {
  if (!context || !context.request) return {};
  const tags = {
    method: getValue(context.request, 'method')
  };
  if (!context.request.header) return tags;
  const headerTags = getHeaderTags(context.request.header);
  return { ...tags, ...headerTags };
}

function getParams(requestContext, clear) {
  const error = getError(requestContext.errors) || requestContext.error;
  if (!error) {
    return null;
  }

  return {
    error,
    clear,
    tags: getTags(requestContext.context),
    contexts: getProcessedRequestContext(requestContext),
    breadcrumbs: getBreadcrumb(requestContext.context)
  };
}

module.exports = {
  getParams,
  getValue
};
